module.exports = __webpack_public_path__ + "media/assets/press_banner-8d4300e3ae5edc5263af7e9e4b8774d0.jpg";